import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  getQuoteValidation: {
    hasMultipleOrcaPolicies: false,
    loading: false,
    policyProvider: '',
    requested: false,
    webviewsData: null,
  },
  powerUpDetails: null,
  powerUpDetailsByKey: {},
  powerUpDetailsLoading: false,
};

export default handleActions({
  BREED_MULTIBRAND_VALIDATION_FAILED: (state) => ({
    ...state,
    getQuoteValidation: {
      ...state.getQuoteValidation,
      hasMultipleOrcaPolicies: false,
      loading: false,
      policyProvider: null,
      requested: false,
    },
  }),
  BREED_MULTIBRAND_VALIDATION_SUCCEED: (state, { payload }) => ({
    ...state,
    getQuoteValidation: {
      ...state.getQuoteValidation,
      hasMultipleOrcaPolicies: payload.hasMultipleOrcaPolicies,
      loading: false,
      policyProvider: payload.policyProvider,
      requested: true,
      webviewsData: payload.webviewsData,
    },
  }),
  ORCA_GET_POWER_UP_ATTEMPT: (state, { payload }) => ({
    ...state,
    powerUpDetails: null,
    powerUpDetailsByKey: {
      ...state.powerUpDetailsByKey,
      [payload?.productKey]: { data: null, loading: true },
    },
    powerUpDetailsLoading: true,
  }),
  ORCA_GET_POWER_UP_BATCH_ITEM_ATTEMPT: (state, { payload }) => ({
    ...state,
    powerUpDetailsByKey: {
      ...state.powerUpDetailsByKey,
      [payload?.productKey]: { data: null, loading: true },
    },
  }),
  ORCA_GET_POWER_UP_BATCH_ITEM_FAILED: (state, { payload }) => ({
    ...state,
    powerUpDetailsByKey: {
      ...state.powerUpDetailsByKey,
      [payload?.productKey]: { data: null, loading: false },
    },
  }),
  ORCA_GET_POWER_UP_BATCH_ITEM_LOADED: (state, { payload }) => ({
    ...state,
    powerUpDetailsByKey: {
      ...state.powerUpDetailsByKey,
      [payload.productKey]: { data: payload.data, loading: false },
    },
  }),
  ORCA_GET_POWER_UP_FAILED: (state, { payload }) => ({
    ...state,
    powerUpDetailsByKey: {
      ...state.powerUpDetailsByKey,
      [payload?.productKey]: { data: null, loading: false },
    },
    powerUpDetailsLoading: false,
  }),
  ORCA_GET_POWER_UP_LOADED: (state, { payload }) => ({
    ...state,
    powerUpDetails: payload.data,
    powerUpDetailsByKey: payload.productKey ? {
      ...state.powerUpDetailsByKey,
      [payload.productKey]: { data: payload.data, loading: false },
    } : state.powerUpDetailsByKey,
    powerUpDetailsLoading: false,
  }),
  RESET_VALIDATION_BREED_MULTIBRAND: (state) => ({
    ...state,
    getQuoteValidation: {
      ...INITIAL_STATE.getQuoteValidation,
    },
  }),
  VALIDATE_BREED_MULTIBRAND: (state) => ({
    ...state,
    getQuoteValidation: {
      ...state.getQuoteValidation,
      hasMultipleOrcaPolicies: false,
      loading: true,
      policyProvider: null,
      requested: false,
    },
  }),
}, INITIAL_STATE);
